import { render, staticRenderFns } from "./VueImageLightboxCarouselItem.vue?vue&type=template&id=4baede9d&scoped=true"
import script from "./VueImageLightboxCarouselItem.vue?vue&type=script&lang=js"
export * from "./VueImageLightboxCarouselItem.vue?vue&type=script&lang=js"
import style0 from "./VueImageLightboxCarouselItem.vue?vue&type=style&index=0&id=4baede9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baede9d",
  null
  
)

export default component.exports